// plugins/questback.client.ts
import { defineNuxtPlugin } from '#app'
import { QUESTBACK_POPUP_URL, questbackPopupConfig } from '~/utils/questback-config'
import { useUserStore } from '~/stores/user'

declare global {
    interface Window {
        questback?: any
    }
}

export default defineNuxtPlugin(async (nuxtApp) => {
    const featureEnabled = nuxtApp.$config.public.features.questbackSurvey;
    if(!featureEnabled) {
        return;
    }
    
    const userStore = useUserStore()
    try {
        await userStore.checkLogin(false)
    } catch (e) {
        // Not logged in or refresh failed → do not show Questback
    }

    // Extra safety – in case checkLogin resolves but not logged in
    if (!userStore.isLoggedIn) {
        return
    }
    
    // Dynamically inject the script tag
    await new Promise<void>((resolve, reject) => {
        if(window.questback?.popup) {
            return resolve();
        }

        const existing = document.querySelector<HTMLScriptElement>(
            'script[data-questback-popup="1"]'
        )
        if (existing) {
            existing.addEventListener('load', () => resolve())
            existing.addEventListener('error', () => reject())
            return
        }

        const script = document.createElement('script')
        script.src = '/scripts/questback.popup-1.0.1.min.js'
        script.async = true
        script.dataset.questbackPopup = '1'

        script.onload = () => resolve()
        script.onerror = () =>
            reject(new Error('Failed to load questback.popup script'))

        document.head.appendChild(script)
    })

    if (!window.questback?.popup) {
        console.warn('Questback popup object not found on window')
        return
    }

    window.questback.popup.create(QUESTBACK_POPUP_URL, questbackPopupConfig)
})
